var swiper = new Swiper.default('.main-slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }

});

$(".category-slider").each(function(index, element){
  var $this = $(this);

  var wrapper = $this.next('.arrows-wrapper');
  wrapper.find('.swiper-button-prev').addClass("btn-prev-" + index);
  wrapper.find(".swiper-button-next").addClass("btn-next-" + index);

  var slider = new Swiper.default(element, { 
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.btn-next-' + index,
        prevEl: '.btn-prev-' + index
      },
  });
});